import React, { forwardRef, ReactElement, useEffect, useState } from 'react';
import { regexValidation } from '../../../../utils/cob-utils';
import InputDropdownState from './components/InputDropdownState/InputDropdownState';

export interface IStateProps {
    addressType?: 'mailing'|'home';
    className?: string;
    inputClass?: string;
    id?: string;
    errorText?: string;
    label?:  string | ReactElement | ReactElement[];
    name: string;
    error?: boolean;
    required?: boolean;
    requiredMessage?: string;
    placeholder?: string;
    alternate?: boolean;
    maxLength?: number;
    invalidErrorMessage?: string;
    valid?: [boolean, (arg?: any) => void];
    value?: string;
    useSuccessIcon?: boolean;
    showSuccessIcon?: boolean;
    mixed?: boolean;
    abbreviation?: boolean;
    useOutsideValidation?: boolean;
    setValueCallback: THandlerFunction;
    onBlurCallback?: (((value: React.FocusEvent<HTMLSelectElement>) => void) & React.FocusEventHandler<any>);
    onFocusCallback?: (((value: React.FocusEvent<HTMLSelectElement>) => void) & React.FocusEventHandler<any>);
    onKeyDownCallback?: (((e: React.KeyboardEvent<Element>) => void) & React.KeyboardEventHandler<any>);
    disabled?: boolean;
    isPrefill?: boolean;
    resetToggle?: boolean;
}

const StateField = (({    
    value = '',
    setValueCallback,
    onBlurCallback,
    onFocusCallback,
    useSuccessIcon,
    showSuccessIcon,
    useOutsideValidation,
    valid,
    isPrefill,
    resetToggle,
    ...rest 
}: IStateProps, ref: React.Ref<any>) => {
    const [showIcon, setShowIcon] = useState(false);
    const [isFieldValid, setIsFieldValid] = useState(false);
    const [isBlurred, setIsBlurred] = useState(false);
    const regex = regexValidation();
    const validity = valid ?? [isFieldValid, setIsFieldValid];

    const validateField = () => {
        if (value === '') {
            return false;
        }
        return regex.state.test(value);
    };

    const focusHandler = (e: React.FocusEvent<HTMLSelectElement>): void => {
        if (e.type === 'blur') {
            onBlurCallback && onBlurCallback(e);
            setIsBlurred(true);
            handleSuccessIcon(false);
            return;
        }
        // React 16.14 only maps blur and focus to onFocus handler
        // no other events will hit this
        onFocusCallback && onFocusCallback(e);
        setIsBlurred(false);
        handleSuccessIcon(true);
    };

    const handleSetValue = (value: string): void => {
        // invoked on onChange in InputDropdownState
        // only if valid option in options via InputDropdownState
        setValueCallback && setValueCallback(value);
    };

    const handleSuccessIcon = (isActive: boolean): void => {
        const isShowIcon = (useOutsideValidation ?? true) && validateField() && !isActive;
        setShowIcon(isShowIcon);
    };

    useEffect(() => {
        if (useOutsideValidation === undefined) {
            return;
        }

        if (useOutsideValidation && !validity[0]) {
            validity[1](true);
        }

        handleSuccessIcon(!useOutsideValidation);
    }, [value, useOutsideValidation, isBlurred]);


    useEffect(() => {
        if (isPrefill) {
            setShowIcon(false);
        }
    }, [isPrefill]);
    
    return (
        <InputDropdownState
            {...rest}
            ref={ref}
            value={value}
            setValue={handleSetValue}
            onBlur={focusHandler}
            onFocus={focusHandler}
            valid={validity}
            useSuccessIcon={useSuccessIcon}
            showSuccessIcon={showSuccessIcon !== undefined ? showSuccessIcon : showIcon}
            showExclamationError
            resetToggle={resetToggle}
        />
    );
});

export default forwardRef(StateField);